import cn from "classnames"

import { Psychologist } from "utils/interfaces"
import { FriendlyLabelsStorage } from "components/Labels"
import { Card, NobodyLikedCard } from "modules/SelectionOfPsychologists/components"
import { FAQContainer } from "modules/SelectionOfPsychologists/FAQContainer"
import style from "modules/SelectionOfPsychologists/style.module.scss"
import { FRIENDLY_LABELS } from "components/Labels/constants"
import { PSYCHOLOGIST_COUNT } from "utils/env-management"

function getMaxHeightLabels(profiles: Psychologist[]) {
    function sumOfLabels(size: number) {
        const isFriendlyEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.FRIENDLY)
        const isFemFriendlyEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.FEM)
        const isBelieverEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.BELIEVER)
        function getEnabledLabelsCount(psy: Psychologist): number {
            //believer label is longer
            const believer = psy.working_with.adults.believer && isBelieverEnabled ? 2 : 0
            const fem = Number(psy.working_with.adults.fem && isFemFriendlyEnabled)
            const friendly = Number(psy.working_with.adults.friendly && isFriendlyEnabled)
            const foreigner = Number(psy.working_with?.adults.foreigner)

            return fem + friendly + foreigner + believer
        }

        return profiles.some((psy) => getEnabledLabelsCount(psy) === size)
    }

    if (sumOfLabels(3) || sumOfLabels(4)) {
        return "survey-results__labels-bigger"
    } else if (sumOfLabels(2) || sumOfLabels(1)) {
        return "survey-results__labels-smaller"
    } else return ""
}

interface Props {
    profiles: Psychologist[]
    freeBooking?: boolean
    className?: string
}

export function Cards({ profiles, freeBooking, className }: Props) {
    const labelsBlockMaxHeight = getMaxHeightLabels(profiles)

    return (
        <div className={cn(style.cards, className)}>
            <div className="columns is-multiline">
                {profiles.map((psy, index) => (
                    <div key={index} className="column is-6-tablet is-4-desktop is-flex">
                        <Card
                            labelsBlockMaxHeight={labelsBlockMaxHeight}
                            psy={psy}
                            index={`${index + 1}`}
                            freeBooking={freeBooking}
                        />
                    </div>
                ))}
                {!freeBooking && (
                    <div className="column is-6-tablet is-4-desktop is-flex">
                        <NobodyLikedCard
                            headline="Каталог психологов"
                            secondary={`Больше ${PSYCHOLOGIST_COUNT} других проверенных психологов Alter.`}
                        />
                    </div>
                )}
            </div>
            <FAQContainer />
        </div>
    )
}
